import React from 'react'
import get from 'lodash/get'
import { i18nTranslate } from 'src/utils'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Image, Button, Nav, Row, Col } from 'react-bootstrap'
/* import { getFrequencyList } from 'src/deps' */
import { LinkWithLocale } from 'src/views/components'
import { pageNames } from 'src/routes/pathParams'
import {
  cartContainer,
  //catalogContainer,
  subscriptionContainer,
} from 'src/models'
import { Icons, ConfirmationModal } from 'src/views/components'
import AccordionBlock from '../AccordionBlock'
import { convertToBoolean, getImageFromProperty } from 'src/utils'
import { getFrequenciesBasedOnAdminConfig } from 'src/deps/NuskinSubscriptionDeps'
import './styles.scss'
import PriceSubscription from '../Price/PriceSubscription'
import CartScanCard from 'src/views/components/CartBlock/CartScanCard/CartScanCard'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
@observer
class SubscriptionProductTileLegacy extends React.Component {
  @observable enableConfirmation = false
  @observable skipConfirmation = false
  @observable cancelConfirmation = false
  @observable isSkippedSubscription = false
  @observable isSkipCallInProgress = false
  @observable isDeleteCallInProgress = false
  @observable removeItemSubscription = false
  @observable scanCardShow = false
  // @observable disableNonActiveMonth =
  //   get(this.props, 'selectedMonth', 0) !==
  //   get(this.props, 'lastOrderProcessedMonth', 0) + 1
  // this will be an issue
  // if lastOrderProcessedMonth is nov ( two month once)
  // no order in dec
  // selected month = jan

  @observable disableNonActiveMonth = this.props.disableNonActiveMonth || false
  // selected month == current calendar month ?
  //  month_of_lastorderprocessingdate != current calendar month :
  //  selectedMonth == (current calendar month + 1) &&  month_of_lastorderprocessingdate == current calendar month

  // since disableNonActiveMonth depends on props, initializing it as a class field will not update the value on re-rendering
  // hence if previous props and the current props mismatch, disableNonActiveMonth is reassigned with new value
  componentDidUpdate(prevProps) {
    const currentProps = this.props
    if (
      prevProps.disableNonActiveMonth !== currentProps.disableNonActiveMonth
    ) {
      this.disableNonActiveMonth = currentProps.disableNonActiveMonth
    }
  }

  handleFrequencyChange = async (quantity, itemId, subscriptionReq) => {
    const { handleFrequencyChange, data } = this.props
    const { subscription } = subscriptionReq
    const { frequencyPeriod, frequencyType } = subscription
    const value = [frequencyPeriod, frequencyType].join('-')
    handleFrequencyChange && (await handleFrequencyChange(data, value))
  }
  handleQuantityChange = async count => {
    const { handleQuantityChange, data } = this.props
    return handleQuantityChange && (await handleQuantityChange(data, count))
  }
  renderFrequencyView = () => {
    // const { selectedMonth, lastOrderProcessedMonth, currentMonth } = this.props
    const {
      frequencyPeriod,
      frequencyType,
      /*itemInfo  , currencySign */
    } = this.props?.data || {}
    const { disableActions = false } = this.props
    /*const frequencyOptionList = getFrequencyList(itemInfo[0].properties)
    const selectedFrequencyValue = [frequencyPeriod, frequencyType].join('-')
    const selectedFrequency = frequencyOptionList.findIndex(
      frequencyOption => frequencyOption.value === selectedFrequencyValue
    )*/
    const frequencyValue = `${frequencyPeriod}-${frequencyType}`
    const frequenciesBasedOnAdminConfig = getFrequenciesBasedOnAdminConfig()
    const subscriptionVal = frequenciesBasedOnAdminConfig.filter(
      item => frequencyValue == item.value
    )
    let frequency =
      subscriptionVal?.[0]?.label ||
      frequenciesBasedOnAdminConfig?.[0]?.label ||
      ''

    return (
      <div className="frequency-wrapper frequency-width">
        <div
          className={` align-items-center ${
            this.disableNonActiveMonth && 'disabled'
          }`}>
          <span>{frequency}</span>
          {/* <SubscriptionDropDown
            disableActions={disableActions}
            frequencyPeriod={frequencyPeriod}
            frequencyType={frequencyType}
            itemId={0}
            quantity={0}
            handleSubscriptionChange={this.handleFrequencyChange}
          /> */}
          {/*
            <div className="d-flex frequency-title align-items-center text-uppercase pr-2">
              <Trans i18nKey="subscriptionProdTile.frequency">
                Frequency:{' '}
              </Trans>
            </div>
            <div>
            <FrequencyDropdown
              customItemClass={'d-flex'}
              frequencyOptionList={frequencyOptionList}
              selectedFrequency={selectedFrequency > -1 ? selectedFrequency : 0}
              onChange={this.handleFrequencyChange}
              itemInfo={itemInfo}
              isToShowSmallText={
                application.isMobile || application.isTablet
                  ? !this.isToShowSmallText
                  : this.isToShowSmallText
              }
              transFrequency="subscriptionProdTile"
            />
            </div>*/}
        </div>
      </div>
    )
  }
  renderQuantity = () => {
    // const { selectedMonth, lastOrderProcessedMonth, currentMonth } = this.props
    const id = this.props?.data?.id || 1
    const quantity = this.props?.data?.itemInfo?.[0]?.quantity || 1
    const maxpurchasequantity =
      this.props?.data?.itemInfo?.[0]?.properties?.maxpurchasequantity || 5
    const productInfo = this.props?.data?.itemInfo?.[0]?.properties || {}
    const availableToCSR = productInfo?.availabletocsr || ''
    const availableToStoreFront = convertToBoolean(
      productInfo?.availabletostorefront || 'true'
    )
    const availableInStore = productInfo?.availableinstore || ''
    return (
      <div className={`cart-quantity-wrapper p-0`}>
        <div
          className={` justify-content-lg-end justify-content-md-end align-items-center
          ${this.disableNonActiveMonth && 'disabled'}`}>
          <div className="p-0 subs-cart-quantity">
            {/* <div
              className={`Dropdown-wrapper w-100 ${
                availableToCSR > 0 &&
                !availableToStoreFront &&
                availableInStore !== '6' &&
                'disabled'
              }`}>
              <SubscriptionQuantityDropdown
                quantity={quantity}
                className="p-0"
                cartItemId={id}
                maxCartItemLimit={maxpurchasequantity}
                handleCartQuantityChange={this.handleQuantityChange}
                transCart="viewCart"
                isPVAssistant={this.props.isPvAssistantPage}
              />
            </div> */}
            <div>
              <span>{i18nTranslate('subscription.legacyQuantity', 'Qty')}</span>
              <span className="mr-1">{':'}</span>
              <span>{quantity}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
  handleRemoveDisableCondition = () => {
    this.isDeleteCallInProgress = false
  }

  handleSkipDisableCondition = () => {
    this.isSkipCallInProgress = false
  }

  handleConfirmation = () => {
    if (this.skipConfirmation) {
      const { handleSkipItem, data } = this.props
      data.isSkippedSubscription = this.isSkippedSubscription
      this.isSkipCallInProgress = true
      handleSkipItem && handleSkipItem(data, this.handleSkipDisableCondition)
    } else if (this.cancelConfirmation) {
      const { handleCancelItem, data } = this.props
      this.isDeleteCallInProgress = true
      handleCancelItem &&
        handleCancelItem(data, this.handleRemoveDisableCondition)
    } else if (this.removeItemSubscription) {
      const { handleItemProcessing, data } = this.props
      handleItemProcessing &&
        handleItemProcessing(data, this.handleSkipDisableCondition)
    }
    this.skipConfirmation = false
    this.cancelConfirmation = false
    this.enableConfirmation = false
    this.removeItemSubscription = false
  }

  handleSkipItem = () => {
    this.skipConfirmation = true
    this.isSkippedSubscription = true
    this.enableConfirmation = true
  }

  handleUnSkipItem = () => {
    this.skipConfirmation = true
    this.isSkippedSubscription = false
    this.enableConfirmation = true
  }

  handleItemProcessing = () => {
    this.removeItemSubscription = true
  }
  handleCancelItem = () => {
    this.cancelConfirmation = true
    this.enableConfirmation = true
  }
  renderSkipConfirmation = () => {
    let isSkipped = this.props?.data?.properties?.isSkipped || false
    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
    } else {
      isSkipped = false
    }
    return (
      <>
        <p className="text-danger m-0 d-flex justify-content-start">
          {this.skipConfirmation
            ? isSkipped
              ? i18nTranslate(
                  'subscriptionProdTile.unskipConfirmation',
                  'UNSKIP?'
                )
              : i18nTranslate('subscriptionProdTile.skipConfirmation', 'SKIP?')
            : i18nTranslate('subscriptionProdTile.cancel', 'CANCEL?')}
        </p>
        <Button
          variant="transparent"
          className="skip-button rounded-0 confirmation-button text-uppercase"
          onClick={this.handleConfirmation}>
          {i18nTranslate('subscriptionProdTile.yes', 'YES')}
        </Button>
        <span className="separater">|</span>
        <Button
          variant="transparent"
          className="skip-button rounded-0 trash-button pr-0 pl-3"
          onClick={() => {
            this.skipConfirmation = false
            this.cancelConfirmation = false
            this.enableConfirmation = false
          }}>
          {i18nTranslate('subscriptionProdTile.no', 'NO')}
        </Button>
      </>
    )
  }
  renderSkipButton = () => {
    let isSkipped = this.props?.data?.properties?.isSkipped || false
    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
    } else {
      isSkipped = false
    }
    const { isProductStatusInactive = false, disableActions = false } =
      this.props
    if (isSkipped) {
      return (
        <>
          <Button
            variant="transparent"
            className={`${
              isProductStatusInactive ? 'disabled' : ''
            } skip-button rounded-0 text-uppercase primary-button ${
              this.disableNonActiveMonth && 'disabled'
            }`}
            onClick={this.handleUnSkipItem}
            data-testid="qa-user-sub-product-skip"
            disabled={this.isSkipCallInProgress || disableActions}>
            {i18nTranslate('subscriptionProdTile.unskip', 'unskip')}
          </Button>
          {/* <span className="separater">|</span> */}
          {/* <Button
            variant="transparent"
            className={`skip-button shadow-none rounded-0 trash-button pb-0 pr-0 pl-3 primary-button ${this
              .disableNonActiveMonth && 'disabled'}`}
            onClick={this.handleCancelItem}
            data-testid="qa-user-sub-product-cancel"
            disabled={this.isDeleteCallInProgress || disableActions}>
            <Icons
              name="CRUD"
              icontype="delete"
              customicon="Delete"
              width="20px"
              alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
              ariaLabel={i18nTranslate('subscription.trashIcon', 'trash icon')}
              fill="#3a3a3a"
            />
          </Button> */}
        </>
      )
    } else {
      return (
        <>
          <Button
            variant="transparent"
            className={`${
              isProductStatusInactive ? 'disabled' : ''
            } skip-button rounded-0 text-uppercase primary-button ${
              this.disableNonActiveMonth && 'disabled'
            }`}
            onClick={this.handleSkipItem}
            data-testid="qa-user-sub-product-skip"
            disabled={this.isSkipCallInProgress || disableActions}>
            {i18nTranslate('subscription.skipText', 'Skip')}
          </Button>
          {/* <span className="separater">|</span> */}
          {/* <Button
            variant="transparent"
            className={`skip-button shadow-none rounded-0 trash-button pb-0 pr-0 pl-3 primary-button
              ${this.disableNonActiveMonth ? 'disabled' : ''}`}
            onClick={this.handleCancelItem}
            data-testid="qa-user-sub-product-cancel"
            disabled={this.isDeleteCallInProgress || disableActions}>
            <Icons
              name="CRUD"
              icontype="delete"
              customicon="Delete"
              width="20px"
              alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
              ariaLabel={i18nTranslate('subscription.trashIcon', 'trash icon')}
              fill="#3a3a3a"
            />
          </Button> */}
        </>
      )
    }
  }
  handleCancelOperation = () => {
    this.skipConfirmation = false
    this.cancelConfirmation = false
    this.enableConfirmation = false
    this.removeItemSubscription = false
  }

  handleScan = () => {
    this.scanCardShow = true
  }

  toggleQuickView = () => {
    this.scanCardShow = false
  }

  renderScanCardBtn = productInfo => {
    return (
      productInfo.scanQualifiedCount > 0 && (
        <div
          className="d-flex justify-content-center text-uppercase"
          data-testid="qa-ScanCard">
          <Button className="scan-card-btn" onClick={this.handleScan}>
            {i18nTranslate('cart.scanCard', 'Scan Card')}
          </Button>
        </div>
      )
    )
  }

  renderRedeemedScanCards = () => {
    const scanCardDetails = cartContainer.scanCardDetails || []
    const subscriptionId = this.props?.data?.id || 1
    let scanArr =
      scanCardDetails?.filter(
        card => card?.subscriptionId === subscriptionId
      ) || []

    return (
      scanArr?.length > 0 && (
        <>
          <p className="text-uppercase redeemed-text mb-0">
            {i18nTranslate('subscription.redeemedCard', 'Redeemed Scan Cards')}
          </p>
          {scanArr?.map(item => (
            <p
              className="mb-0 scancard-number text-dark"
              key={`card-${item?.id}`}>
              {item?.scancardNumber}
            </p>
          ))}
        </>
      )
    )
  }

  getItemLink = (linkOptions = {}) => {
    const { data = {} } = this.props || {}
    const { items = [], isBundle = false, bundle = {} } = linkOptions || {}
    const productSlug = items?.itemInfo?.[0]?.properties?.slug || ''
    let skuVariant = data?.properties?.slug || ''

    if (!skuVariant) {
      skuVariant = items?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug || ''
    }

    const productID = isBundle
      ? bundle?.productId
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.productId

    const productOrSlugId = productSlug ? productSlug : productID
    const categoryId = data?.properties?.categoryId || ''
    let productQueryParams = new URLSearchParams()
    if (categoryId) {
      productQueryParams.append('categoryId', categoryId)
    }
    if (skuVariant) {
      productQueryParams.append('variant', skuVariant)
    }
    productQueryParams = productQueryParams.toString()
    const url =
      `${pageNames.product}/${productOrSlugId}` +
      (productQueryParams ? `?${productQueryParams}` : '')
    return url
  }

  renderProductDetails(items, productInfo, productID, bundle, isBundle) {
    // const { selectedMonth, lastOrderProcessedMonth, currentMonth } = this.props
    const {
      isStockError = false,
      isProductStatusInactive = false,
      disableActions = false,
      data = {},
    } = this.props

    const customClass =
      isStockError || isProductStatusInactive ? 'disabled' : ''
    const skuID = isBundle
      ? bundle?.id || ''
      : items?.itemInfo?.[0]?.skus?.[0]?.id || ''
    const slug = this.props?.data?.properties?.slug || ''
    const productOrSlugId = slug ? slug : productID
    const categoryId = data?.properties?.categoryId || ''
    // const url = categoryId
    //   ? `${pageNames.product}/${productOrSlugId}?categoryId=${categoryId}`
    //   : `${pageNames.product}/${productOrSlugId}`

    const url = this.getItemLink({ items, isBundle, bundle })

    const totalValue = items?.itemInfo?.[0]?.totalValue || {}
    const { originalPrice = '', priceAfterDiscount = '' } = totalValue
    const { currencySign } = this.props
    const priceObj = {
      currencySymbol: currencySign,
      price: parseFloat(originalPrice),
      discountedPrice: parseFloat(priceAfterDiscount),
      totalValue,
    }
    let isSkipped = this.props?.data?.properties?.isSkipped || false

    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
    } else {
      isSkipped = false
    }
    const availableToCSR = productInfo?.availabletocsr || ''
    const availableToStoreFront = convertToBoolean(
      productInfo?.availabletostorefront || 'true'
    )
    const availableInStore = productInfo?.availableinstore || ''
    const pvValue = items?.properties?.pointValue || '00.00'
    const isStarterKit = productInfo?.isstarterkit || 'false'
    const partNumber = productInfo?.partnumber || ''
    const variant = productInfo?.variant || ''
    const quantity = this.props?.data?.itemInfo?.[0]?.quantity || 1
    const productAddedText = i18nTranslate(
      'subscription.productAddedText',
      'Added Successfully'
    )
    const promotionArray =
      this.props?.data?.itemInfo?.[0]?.promotions?.[0]?.breakup || ''

    const productName = items?.itemInfo?.[0]?.skus?.[0]?.name || ''
    return (
      <>
        <div
          className={`prod-desc-left  ${customClass} ${
            (isSkipped ||
              (availableToCSR > 0 &&
                availableInStore !== '6' &&
                !availableToStoreFront)) &&
            'disabled'
          }`}>
          <div className="d-flex justify-content-between">
            <div>
              <LinkWithLocale
                to={{
                  pathname: url,
                }}
                className={`text-decoration-none`}>
                <h3
                  className="prod-desc-title text-capitalize paragraph-m"
                  data-testid="qa-user-sub-product-name">
                  {`${isBundle ? bundle?.name : productName}${
                    variant && ' - ' + variant
                  }`}
                </h3>
              </LinkWithLocale>
            </div>
            {/* <span
              variant="transparent"
              //</Row>className={`skip-button shadow-none rounded-0 trash-button pb-0 pr-0 pl-3 primary-button ${this
              //.disableNonActiveMonth && 'disabled'}`}
              onClick={this.handleCancelItem}
              data-testid="qa-user-sub-product-cancel"
              disabled={this.isDeleteCallInProgress || disableActions}>
              <Icons
                name="CRUD"
                icontype="delete"
                customicon="Delete"
                width="20px"
                alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
                ariaLabel={i18nTranslate('subscription.trashIcon', 'trash icon')}
                fill="#3a3a3a"
              />
            </span> */}
          </div>

          {/* <div className="code-pv-wrap d-flex">
            <p className="prod-desc-item-number mr-1 mb-0 paragraph-s">
              <Trans i18nKey="pdp.itemNumber">Item #</Trans>
            </p>
            <p className="item-number-value mb-0 mr-2 paragraph-s">{`: ${skuID} `}</p>
            <p
              className="prod-desc-code-pv mr-1 mb-0 d-none paragraph-s"
              data-testid="qa-user-sub-product-pv-value">
              <Trans i18nKey="subscriptionProdTile.pvValue">PV: </Trans>
            </p>
            <p className="code-pv-value mb-0 d-none paragraph-s">{pvValue}</p>
          </div> */}
          {/* {promotionArray && (
            <ProductPromotion
              promotion={promotionArray}
              isSubscription={true}
              isProductCard={true}
            />
          )}  */}
          {/* <SubscriptionsProductPrice {...totalValue} isSubscription={true} /> */}
          <div className="d-inline-block mb-2 w-100">
            <PriceSubscription
              classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
              transactionPrice={priceObj}
              isStarterKit={isStarterKit}
              partNumber={partNumber}
            />
          </div>

          <>
            {(isStockError || disableActions || isProductStatusInactive) && (
              <div className="d-flex d-md-block flex-column">
                <div
                  className="unavailable-item-text-with-border mb-2"
                  style={{
                    whiteSpace: this.props.isPvAssistantPage ? 'nowrap' : '',
                  }}>
                  {isStockError || disableActions
                    ? i18nTranslate('subscription.outOfStock', 'Out of Stock')
                    : isProductStatusInactive
                      ? i18nTranslate(
                          'subscriptions.productStatusInactive',
                          'INACTIVE PRODUCT'
                        )
                      : i18nTranslate(
                          'subscription.unavailable',
                          'Unavailable'
                        )}
                </div>
              </div>
            )}
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-row text-center">
                <div> {this.renderQuantity()}</div>
              </div>
              {!this.props.isPvAssistantPage && (
                <div className="frequency-change">
                  {this.renderFrequencyView()}
                </div>
              )}
            </div>
          </>
        </div>

        <div className="prod-desc-right d-flex justify-content-between mt-3">
          {/* {!(
            isStockError ||
            isProductStatusInactive ||
            this.props.isPvAssistantPage
          ) && (
            <div
              className={`action-button mt-2 d-flex justify-content-center align-items-center`}> */}
          {/* {this.enableConfirmation
                ? this.renderSkipConfirmation()
                : this.renderSkipButton()} */}
          {/* {!this.enableConfirmation && this.renderSkipButton()}
            </div>
          )} */}
          {this.props.isProductAddedInSubscriptionScreen && (
            <div
              className={`action-button d-flex justify-content-center align-items-center`}>
              <label className="add-label-success-msg mb-0">
                {productAddedText}
              </label>
              <span className="success-tick-showall ml-1">
                <Icons
                  name="CRUD"
                  icontype="circled-tick"
                  className="subscription-add-icon"
                  width="16px"
                  color="#3e7957"
                />
              </span>
            </div>
          )}
          {/* {this.renderScanCardBtn(productInfo)} */}
        </div>
        {this.renderRedeemedScanCards()}
      </>
    )
  }
  handleProductSelectCheckbox = (id, pv) => {
    const { handleProductDelete } = this.props
    handleProductDelete && handleProductDelete(id, pv)
  }

  renderBundleProducts(productInfo) {
    const image = get(
      productInfo,
      'skuProperties.primaryimage',
      get(productInfo, 'skuProperties.imageURL')
    )
    const variant = productInfo?.variant || ''
    const {
      isStockError = false,
      isProductStatusInactive = false,
      isToDisableDeleteCheckbox = false,
    } = this.props
    const availableInStore = productInfo?.availableinstore || ''

    const items = this.props?.data || {}
    const pvValue = items?.properties?.pointValue || '00.00'
    const name = productInfo?.name || ''
    const size = productInfo?.skuProperties?.size || 1
    const quantity = productInfo?.skuQuantity || 1
    const id = productInfo?.id || 1
    const productID = productInfo?.productId || ''
    const url = productID ? `${pageNames.product}/${productID}` : ''
    const inventory = productInfo?.inventory || ''
    // const availableToStoreFront = convertToBoolean(
    //   productInfo?.availabletostorefront || 'true'
    // )

    return (
      <Row
        noGutters
        className="prod-desc-wrapper d-flex w-100 justify-content-center bundle-product-tile-container">
        <Col lg={2} />
        <Col lg={3} className="subitem-img">
          <LinkWithLocale
            to={{
              pathname: url,
            }}
            className={`prod-image-wrapper w-100 h-100`}>
            <Image
              src={image}
              alt={name}
              className={`mw-100 mh-100 prod-img`}
              data-testid="qa-user-sub-product-image"
            />
          </LinkWithLocale>
        </Col>
        <Col lg={7} className="subitem-details">
          <div className={`prod-desc-left`}>
            <LinkWithLocale
              to={{
                pathname: url,
              }}
              className={`text-decoration-none`}>
              <div
                className="prod-desc-title text-capitalize"
                data-testid="qa-user-sub-product-name">
                {`${name || variant}`}
              </div>
            </LinkWithLocale>
            <p className="mb-0">{`${'itemid: ' + id}`}</p>
            <p className="mb-0">{`${'qty: ' + quantity}`}</p>
            <p className="mb-0">{`${size && 'size: ' + size}`}</p>

            {inventory?.toLowerCase() === 'out of stock' && (
              <div className="unavailable-item-text-with-border mb-2">
                {i18nTranslate('subscription.outOfStock', 'Out of Stock')}
              </div>
            )}

            {/* <div className="code-pv-wrap d-flex">
              <p
                className="prod-desc-code-pv mr-1 mb-0 d-none"
                data-testid="qa-user-sub-product-pv-value">
                <Trans i18nKey="subscriptionProdTile.pvValue">PV: </Trans>
                <p className="code-pv-value mb-0 d-none">{pvValue}</p>
              </p>
            </div> */}
          </div>
          {/* For bundle section availableToStoreFront is commented as it's not available, verified with BE team */}
          {/* {(isStockError ||
            isProductStatusInactive ||
            availableInStore === '3' ||
            availableInStore === '5') &&
            !availableToStoreFront && (
              <div
                className="out-of-stock position-relative w-100 text-center text-uppercase"
                style={{
                  whiteSpace: this.props.isPvAssistantPage ? 'nowrap' : '',
                }}>
                {i18nTranslate('subscriptions.outofstock', 'Out Of Stock')}
              </div>
            )} */}
        </Col>
      </Row>
    )
  }

  renderShippingAddress = (address = {}, isFromModal = false) => {
    const {
      addressLine1 = '',
      addressLine2 = '',
      street1 = '',
      street2 = '',
      city = '',
      state = '',
      zipCode = '',
      zip = '',
      // phone = '',
      country = '',
    } = address
    const actualZip = zipCode || zip
    const isAddressAvailable =
      addressLine1 != '' ||
      addressLine2 != '' ||
      street1 != '' ||
      street2 != '' ||
      city != '' ||
      state != '' ||
      actualZip != '' ||
      country != ''
    return (
      <>
        <div
          className="subscription-shipping-addr w-100 d-inline-block"
          data-testid="qa-user-sub-shipping-address">
          <Row noGutters className={'align-items-center'}>
            <Col className="col-10 text-uppercase shipping-text">
              {i18nTranslate('subscription.shippingTitle', 'Shipping Address')}
            </Col>
          </Row>
          {isAddressAvailable && (
            <p className="subscription-shipping-address">
              {addressLine1 +
                addressLine2 +
                street1 +
                street2 +
                ' ' +
                city +
                ', ' +
                state +
                ', ' +
                actualZip}
              <br />
              {country}
            </p>
          )}
        </div>
      </>
    )
  }
  renderPaymentMethod = (payment = {}, isFromModal = false) => {
    const {
      name = '',
      firstName = '',
      lastName = '',
      cardExpirationYear = '',
      cardExpirationMonth = '',
      expiryYear = '',
      expiryMonth = '',
      paymentType: type = '',
      displayName = '',
      // properties = {},
    } = payment

    /*
     * Temporarily splitting card number into 4 per group
     * TODO: Need to split card number based on card type
     */
    const cardNumber = (payment?.cardNumber || '').replace(
      /^(.{4})(.{4})(.{4})(.*)$/,
      '$1-$2-$3-$4'
    )
    const defaultSelectedMonth =
      subscriptionContainer?.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0

    const month = this.props?.location?.queryParams?.month || ''
    let selectedMonth = 0
    const lastOrderProcessingDate =
      subscriptionContainer?.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0

    const lastOrderProcessedMonth =
      new Date(lastOrderProcessingDate).getMonth() + 1
    const lastSubscriptionOrderStatus =
      subscriptionContainer?.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    if (subscriptionContainer.selectedMonth != '') {
      selectedMonth = subscriptionContainer.selectedMonth
    } else {
      selectedMonth = defaultSelectedMonth
    }
    const totalActiveSubscriptionCount =
      cartContainer?.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount || ''
    const accountNumber = payment?.properties?.accountNumber || ''
    const bankName = payment?.properties?.bankName || ''
    const endingDigits = accountNumber
      ? accountNumber.substr(accountNumber.length - 4)
      : undefined
    const cardDetail =
      (cardExpirationMonth || expiryMonth) +
      (cardExpirationMonth != '' || expiryMonth != '' ? '/' : '') +
      (cardExpirationYear || expiryYear)

    return (
      <>
        <div
          className="subscription-payment w-100 d-inline-block"
          data-testid="qa-user-sub-payment-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center'}>
              {lastOrderProcessedMonth == selectedMonth &&
                (lastSubscriptionOrderStatus.toLowerCase() ===
                  'payment_failed' ||
                  lastSubscriptionOrderStatus.toLowerCase() ===
                    'order_failed') &&
                totalActiveSubscriptionCount != 0 &&
                month !== 'showall' && (
                  <div className="col-1 warningIcnDiv">
                    <Icons
                      name="product-icon"
                      icontype="danger-warning"
                      className="subscription-wrn-icon"
                      color="#8C6E43"
                    />
                  </div>
                )}
              <Col className="col-9 text-uppercase shipping-text">
                {i18nTranslate('subscription.paymentTitle', 'Payment Method')}
              </Col>
            </Row>
          )}
          {type && type.toLowerCase() === 'ach' ? (
            <Col className="p-0 text-dark">
              {i18nTranslate('subscription.achPayment', 'ACH')}
              <br />
              {bankName}
              <br />
              {endingDigits && (
                <>{`${i18nTranslate(
                  'payment.accountEndingText',
                  'Account ending in'
                )} - ${endingDigits}`}</>
              )}
            </Col>
          ) : type && type.toLowerCase() === 'paypalsubscription' ? (
            <Col className="p-0 text-dark">
              {i18nTranslate(
                'subscription.paypalsubscription',
                'PayPal Account'
              )}
              <br />
              {displayName}
            </Col>
          ) : (
            type &&
            (type?.toLowerCase() === 'creditcard' ||
              type?.toLowerCase() === 'debitcard') && (
              <p className="p-0 text-dark">
                {name != null && `${firstName || name}`}
                {lastName != null && ` ${lastName}`}
                {(name != null && name != '') ||
                  (lastName != null && lastName != '' && <br />)}
                {cardNumber}
                {cardNumber != null && cardNumber != '' && <br />}
                {cardDetail}
              </p>
            )
          )}
        </div>
      </>
    )
  }
  renderShippingMethod = (shipping = {}, isFromModal = false) => {
    const shippingMethods = this.props?.shippingMethods || []
    let selectedShippingMethod = []
    if (shippingMethods?.length) {
      selectedShippingMethod = shippingMethods.filter(item => {
        {
          return item?.shippingMethodId == shipping.method
        }
      })
    }
    const shippingMethod = selectedShippingMethod.length
      ? { ...selectedShippingMethod[0] }
      : shipping
    const { method = '', name = '', cost = '0' } = shippingMethod
    const currencySymbol = this.props?.currencySymbol || '$'
    let description = shippingMethod?.description || ''
    const getMonthlyPV =
      subscriptionContainer?.subscriptionPreferenceResponse?.order?.monthlyPV ||
      0

    const shippingCost =
      getMonthlyPV >= 100 &&
      (method.toLowerCase() == 'economy' || name.toLowerCase() == 'economy')
        ? i18nTranslate('subscription.free', 'FREE')
        : `${currencySymbol}${cost}`
    const displayDescription =
      description && description.toLowerCase() != 'none'
        ? `- (${description} business days)`
        : `- ${i18nTranslate('subscription.noItemsAdded', 'No Items Added')}`
    return (
      <>
        <div
          className={`subscription-shipping w-100 d-inline-block`}
          data-testid="qa-user-sub-shipping-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center'}>
              <Col className="col-10 text-uppercase shipping-text">
                {i18nTranslate(
                  'subscription.shippingMethod',
                  'Shipping Method'
                )}{' '}
              </Col>
            </Row>
          )}
          <Col className="p-0 text-dark">
            {method || name ? (
              <>
                {`${method || name} ${displayDescription} ${
                  cost ? shippingCost : ''
                }`}
              </>
            ) : (
              <>
                {i18nTranslate(
                  'subscription.shippingMethodDescription',
                  'No Shipment This Month'
                )}
              </>
            )}
          </Col>
        </div>
      </>
    )
  }

  render() {
    const subscriptionCount = this.props?.totalSubscriptionCount || 0
    const orders =
      subscriptionContainer?.subscriptionPreferenceResponse || 'order'

    const itemId = this.props?.data?.id || '0'
    const shippingAddress =
      subscriptionContainer?.subscriptionPreferenceResponse?.addresses || ''

    const minMonthlyPV = orders?.monthlyPV || '0'
    const {
      isStockError = false,
      isProductStatusInactive = false,
      isToDisableDeleteCheckbox = false,
      data = {},
    } = this.props
    const customClass =
      isStockError || isProductStatusInactive ? 'disabled' : ''
    const items = this.props?.data || {}
    const pv = items?.properties?.pointValue || '00.00'
    const {
      bundle: [bundleItems = {}] = [],
      isBundle,
      optionalCount,
      mandatoryCount,
    } = this.props?.bundleItems || {}
    const _bundle = {
      ...bundleItems,
      ...(bundleItems?.skuProperties || {}),
    }
    //let productInfo = get(this.props, 'data.itemInfo.0.skus.0.skuProperties')
    let productInfo = isBundle
      ? _bundle
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    if (
      productInfo &&
      Object.keys(productInfo) &&
      Object.keys(productInfo).length == 0
    ) {
      productInfo =
        this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties || {}
    }
    const productID = isBundle
      ? _bundle?.productId || ''
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.productId || {}
    /*const defaultSemanticId =
      get(this.props, 'data.itemInfo.0.semantics.0', '') || ''
    const semanticsMapper = get(
      this.props,
      'data.itemInfo.0.properties.semanticsmapper',
      ''
    )*/
    const availableToCSR = productInfo?.availabletocsr || ''
    const availableToStoreFront = convertToBoolean(
      productInfo?.availabletostorefront || 'true'
    )

    /*const semanticId = catalogContainer.getSemanticsMapper(
      semanticsMapper,
      defaultSemanticId
    )*/
    const slug = data?.properties?.slug || ''
    const productOrSlugId = slug ? slug : productID
    const categoryId = data?.properties?.categoryId || ''
    // const url = categoryId
    //   ? `${pageNames.product}/${productOrSlugId}?categoryId=${categoryId}`
    //   : `${pageNames.product}/${productOrSlugId}`

    const url = this.getItemLink({ items, isBundle, bundle: _bundle })

    let isToSelectProduct = false
    if (subscriptionContainer.selectedSubscriptionProducts.has(itemId)) {
      isToSelectProduct = true
    }
    const productImage = getImageFromProperty(
      isBundle
        ? bundleItems?.skuProperties
        : items?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    )
    let pvTitle = i18nTranslate('subscription.pvTitle', 'UNDER 50PV MINIMUM')

    let pvMessage = i18nTranslate(
      'subscription.pvMessage',
      'By deleting this item you will fall below the 50PV minimum and will not earn Nu Skin Rewards on this purchase. Would you like to proceed?'
    )

    let skipUnder = i18nTranslate(
      'subscription.skipUnder',
      'By skipping this item you will fall below the 50PV minimum and will not earn Nu Skin Rewards on this purchase. Would you like to proceed?'
    )

    let skipMessage = i18nTranslate(
      'subscription.skipMessage',
      'Clicking "Skip" below will result in the skipping of this item for this month.'
    )

    let skipSubscription = i18nTranslate(
      'subscription.skipLastSub',
      'By skipping this item you will be processing a skip for your subscription'
    )

    let skipLastSubTitle = i18nTranslate(
      'subscription.skipLastSubTitle',
      'Skip Entire Month?'
    )

    let isSkipped = this.props?.data?.properties?.isSkipped || false
    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
      if (minMonthlyPV + parseFloat(pv) <= 50) {
        skipMessage = i18nTranslate(
          'subscription.unSkipMessage50pv',
          'Clicking "Un Skip" below will result in the Un skipping of this item for this month.'
        )
      } else {
        skipMessage = i18nTranslate(
          'subscription.unSkipMessage',
          'Clicking "Un Skip" below will result in the Un skipping of this item for this month.'
        )
      }
    } else {
      isSkipped = false
      skipMessage = i18nTranslate(
        'subscription.skipMessage',
        'Clicking "Skip" below will result in the skipping of this item for this month.'
      )
    }
    let deleteSubscriptionTitle = i18nTranslate(
      'migratedSubscription.deleteTitle',
      'Are you sure you want to delete this subscription?'
    )
    let deleteSubscriptionMessage = i18nTranslate(
      'migratedSubscription.deleteMessage',
      'Once this subscription is deleted, you will not be able to restore it with a different shipping address and/or payment method than your primary subscription.'
    )
    let deleteSubscription = i18nTranslate(
      'migratedSubscription.delete',
      'Delete Subscription'
    )
    const enableItemLevelProcessing =
      this.props?.data?.enableItemLevelProcessing || false

    const addressInfo = this.props?.data?.addressInfo || {}
    const paymentInfo = this.props?.data?.paymentInfo || {}
    const shippingInfo = this.props?.data?.shippingInfo || {}
    const availableInStore = productInfo?.availableinstore || ''

    const isProps65Warning = convertToBoolean(
      this.props?.data?.itemInfo?.[0]?.properties?.isprop65 || false
    )

    const shippingState = shippingAddress?.state || ''

    return (
      <div className="sub-legacyCard-width border p-3 d-flex flex-wrap">
        <div
          className="d-flex w-100 trash-icon justify-content-end"
          onClick={this.handleCancelItem}
          disabled={this.isDeleteCallInProgress}
          data-testid="qa-user-sub-product-cancel">
          <Icons
            name="CRUD"
            icontype="delete"
            customicon="Delete"
            width="24px"
            alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
            ariaLabel={i18nTranslate('subscription.trashIcon', 'trash icon')}
            fill="#3a3a3a"
            data-testid="qa-user-sub-product-cancel-icon"
          />
        </div>
        <div className="sbs-legacy-pdt-details">
          {/* {!this.props.isPvAssistantPage &&
            (isStockError || isProductStatusInactive) && (
              <div
                className="d-flex w-100 subs-delete-product-checkbox delete-icon"
                onClick={this.handleCancelItem}>
                <Icons
                  name="CRUD"
                  icontype="delete"
                  customicon="Delete"
                  width="24px"
                  alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
                  ariaLabel={i18nTranslate('subscription.trashIcon', 'trash icon')}
                  fill="#3a3a3a"
                  data-testid="qa-subscription-month-dropdown"
                />
              </div>
            )} */}
          <div className="subs-prod-img py-3">
            <LinkWithLocale
              to={{
                pathname: url,
              }}
              className={`prod-image-wrapper w-100 d-inline-block text-center ${
                ((availableToCSR > 0 && availableInStore !== '6') ||
                  isStockError ||
                  isProductStatusInactive ||
                  isSkipped) &&
                !availableToStoreFront &&
                'disabled'
              }`}>
              <Image
                src={productImage || imagePlaceholder}
                alt={productInfo.name}
                className={`mw-100 prod-img ${isSkipped && 'disabled'}`}
                data-testid="qa-user-sub-product-image"
              />
              {(isStockError ||
                isProductStatusInactive ||
                availableInStore === '3' ||
                availableInStore === '5') &&
                !availableToStoreFront && (
                  <div
                    className="out-of-stock position-relative w-100 text-center text-uppercase"
                    style={{
                      whiteSpace: this.props.isPvAssistantPage ? 'nowrap' : '',
                    }}>
                    {i18nTranslate('subscriptions.outofstock', 'Out Of Stock')}
                  </div>
                )}
            </LinkWithLocale>
          </div>
          <div className="prod-desc-wrapper w-100 justify-content-between">
            {this.renderProductDetails(
              items,
              productInfo,
              productID,
              _bundle,
              isBundle
            )}
          </div>
          {/* {isBundle && (
            <div
              className="d-flex w-100"
              data-testid="qa-user-bundle-items-container">
              <Row noGutters className="w-100 pl-3 py-3">
                <span className="px-2 ml-auto qa-count" data-testid="qa-count">
                  <div />
                </span>
                <AccordionBlock
                  className="mr-auto py-0"
                  textClass="text-primary"
                  title="Sub-Items"
                  dataTestId="qa-cart-view"
                  isOutsideAccordion={true}>
                  {[...mandatoryCount, ...optionalCount].map(
                    this.renderBundleProducts.bind(this)
                  )}
                </AccordionBlock>
              </Row>
            </div>
          )} */}
          {this.props.isPvAssistantPage && (
            <div
              className={`pv-items-ranking ml-3 flex-column justify-content-center ${customClass}`}>
              <Button
                variant="transparent"
                className="ranking-icon shadow-none rounded-0 p-0 primary-button"
                style={{ width: '19px' }}
                onClick={() => {
                  this.props.renderUpDown(this.props.index, 'up')
                }}
                disabled={
                  this.props.itemPriority == 1 ||
                  this.props.isToDisableDeleteCheckbox
                }>
                <Icons
                  viewBox="0 0 28 25"
                  name={'CRUD'}
                  color="#707070"
                  icontype={'caretup'}
                  customicon={i18nTranslate(
                    'subscriptions.pvPriorityUp',
                    'Priority Up'
                  )}
                  width="28px"
                />
              </Button>
              <span
                style={{
                  fontSize: '14px',
                  fontFamily: 'GTWalsheimPro-Light',
                }}>
                #{this.props.itemPriority}
              </span>
              <Button
                variant="transparent"
                className="ranking-icon shadow-none rounded-0 p-0 primary-button"
                style={{ width: '19px' }}
                onClick={() => {
                  this.props.renderUpDown(this.props.index, 'down')
                }}
                disabled={
                  this.props.disable || this.props.isToDisableDeleteCheckbox
                }>
                <Icons
                  viewBox="0 0 28 25"
                  name={'CRUD'}
                  color="#707070"
                  icontype={'caretdown'}
                  customicon={i18nTranslate(
                    'subscriptions.pvPriorityDown',
                    'Priority Down'
                  )}
                  width="28px"
                />
              </Button>
            </div>
          )}
          {/* Added component to display confirmation view */}
          {this.enableConfirmation && this.cancelConfirmation && (
            <ConfirmationModal
              showConfirmationModal={this.cancelConfirmation}
              handleConfirm={this.handleConfirmation}
              handleCancel={this.handleCancelOperation}
              handleHide={this.handleCancelOperation}
              // modalMessage={
              //   minMonthlyPV - pv == 0
              //     ? undefined
              //     : minMonthlyPV - pv < 50
              //     ? pvMessage
              //     : undefined
              // }
              // renderText={
              //   minMonthlyPV - pv == 0
              //     ? undefined
              //     : minMonthlyPV - pv < 50
              //     ? pvTitle
              //     : undefined
              // }
              totalSubscriptionLength={subscriptionCount}
              renderText={deleteSubscriptionTitle}
              modalMessage={deleteSubscriptionMessage}
              confirmButtonText={deleteSubscription}
              isToHideCancelButton={true}
              isMigratedSubscriptionDelete={true}
              // isSubscriptionDelete={true}
            />
          )}
          {this.enableConfirmation && this.skipConfirmation && (
            <ConfirmationModal
              showConfirmationModal={this.skipConfirmation}
              handleConfirm={this.handleConfirmation}
              handleCancel={this.handleCancelOperation}
              handleHide={this.handleCancelOperation}
              modalMessage={
                (minMonthlyPV - pv == 0) & (subscriptionCount == 1)
                  ? skipSubscription
                  : (minMonthlyPV < 50) & (minMonthlyPV - pv == 0)
                    ? skipMessage
                    : minMonthlyPV - pv < 50 && this.isSkippedSubscription
                      ? skipUnder
                      : skipMessage
              }
              renderText={
                (minMonthlyPV - pv == 0) & (subscriptionCount == 1)
                  ? skipLastSubTitle
                  : (minMonthlyPV < 50) & (minMonthlyPV - pv == 0)
                    ? undefined
                    : minMonthlyPV - pv < 50
                      ? pvTitle
                      : undefined
              }
              confirmButtonText={
                isSkipped
                  ? i18nTranslate('subscription.unSkipText', 'Un Skip')
                  : i18nTranslate('subscription.skipText', 'Skip')
              }
              totalSubscriptionLength={subscriptionCount}
            />
          )}
        </div>
        <div className="sbs-legacy-pdt-details pl-3">
          <div
            data-testid="qa-user-sub-products-container"
            style={{
              borderRadius: this.props.isProductAddedInSubscriptionScreen
                ? '4px'
                : '',
              opacity: this.props.isProductAddedInSubscriptionScreen ? '1' : '',
              padding: this.props.isProductAddedInSubscriptionScreen
                ? '5px'
                : '',
            }}></div>
          {this.removeItemSubscription && (
            <ConfirmationModal
              showConfirmationModal={this.removeItemSubscription}
              handleConfirm={this.handleConfirmation}
              handleCancel={this.handleCancelOperation}
              handleHide={this.handleCancelOperation}
              modalMessage={`Removal will associate the Shipping Method/Shipping Address/Payment Method at Subscription level`}
              renderText={i18nTranslate(
                'confirm.continueMessage',
                'Do you want to continue ?'
              )} //CX121-4791 - Google Translate
              confirmButtonText={i18nTranslate('subscription.yes', 'YES')}
              cancelButtonText={i18nTranslate('subscription.no', 'NO')}
            />
          )}

          {enableItemLevelProcessing && (
            <Row
              noGutters
              className="d-flex flex-column ml-2 mr-2 shipping-container position-relative">
              <Row noGutters className="pt-2 flex-column flex-md-row">
                {this.renderPaymentMethod(paymentInfo)}
                {this.renderShippingAddress(addressInfo)}
                {this.renderShippingMethod(shippingInfo)}
              </Row>
              {/* <Button
                variant="transparent skip-button rounded-0 text-uppercase primary-button p-0 mt-2 text-left"
                onClick={this.handleItemProcessing}
                data-testid="qa-user-sub-product-remove">
                {i18nTranslate('subscriptionProdTile.remove', 'REMOVE')}
              </Button> */}
            </Row>
          )}
          {isProps65Warning && shippingState.toUpperCase() === 'CA' && (
            <div className="d-flex mt-3">
              <div className="pr-2">
                <Icons
                  viewBox="0 0 28 25"
                  name="product-icon"
                  icontype="danger-warning-prop65"
                  width="28px"
                />
              </div>
              <p className="mb-0">
                <span className="pdp-warning">WARNING: </span>
                {i18nTranslate(
                  'pdp.prop65warning1',
                  'This product can expose you to chemicals including lead,which are known to the State of California to cause cancer',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}{' '}
                <u>
                  {i18nTranslate(
                    'pdp.prop65warning2',
                    'and birth defects or other reproductive harm',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}
                </u>
                .{' '}
                {i18nTranslate(
                  'pdp.prop65warning3',
                  'For more information, go to',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}{' '}
                <Nav.Link
                  className="trackingUrl-link p-0"
                  role="link"
                  target="_blank"
                  href="https://www.P65Warnings.ca.gov/food">
                  {i18nTranslate(
                    'pdp.p65WarningsLink',
                    'www.P65Warnings.ca.gov/food',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}
                </Nav.Link>
              </p>
            </div>
          )}
          {this.scanCardShow && (
            <CartScanCard
              isScanModalOpen={this.scanCardShow}
              toggleQuickView={this.toggleQuickView}
              productInfo={productInfo}
              page="subscription"
              {...this.props}
            />
          )}
        </div>
        {isBundle && (
          <div
            className="sbs-legacy-pdt-details sub-items d-flex w-100"
            data-testid="qa-user-bundle-items-container">
            <Row noGutters className="w-100 pl-3 py-3 sub-items-wrapper">
              <span className="px-2 ml-auto qa-count" data-testid="qa-count">
                <div />
              </span>
              <AccordionBlock
                className="mr-auto py-0"
                textClass="text-primary"
                title={i18nTranslate('subscription.subItems', 'Sub-Items')} //CX121-4791 - Google Translated
                dataTestId="qa-cart-view"
                isOutsideAccordion={true}>
                {[...mandatoryCount, ...optionalCount].map(
                  this.renderBundleProducts.bind(this)
                )}
              </AccordionBlock>
            </Row>
          </div>
        )}
      </div>
    )
  }
}

export default SubscriptionProductTileLegacy
export { SubscriptionProductTileLegacy }
